<template>
  <div
    class="detail-availability"
    data-cy="availability"
  >
    <UnderlinedTitle
      tag="h2"
      tag-class="h5"
      :title="$t('availability.title')"
    />
    <div class="m-availability-links">
      <a
        class="link"
        v-if="resourceURL && isPublic"
        :href="resourceURL"
        target="_blank"
      >
        <i class="icon-play-o" />
        <span>{{ $t('availability.watchOnline') }}</span>
      </a>
      <a
        class="link"
        v-if="buy && resourceURL"
        target="_blank"
        :href="resourceURL"
      >
        <i class="icon-dto-o" />
        <span>{{ $t('availability.buy') }}</span>
      </a>
      <a
        class="link"
        v-if="rent && resourceURL"
        target="_blank"
        :href="resourceURL"
      >
        <i class="icon-vod-o" />
        <span>{{ $t('availability.rent') }}</span>
      </a>
      <a
        class="link"
        v-if="hasDVD"
        :href="$t('url.dvdStore')"
        target="_blank"
      >
        <i class="icon-cd" />
        <span>{{ $t('availability.dvd') }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import UnderlinedTitle from '@components/UnderlinedTitle'
import { mapGetters } from 'vuex'

export default {
  name: 'DetailAvailability',
  components: {
    UnderlinedTitle
  },
  props: {
    resourceURL: {
      type: String,
      default: ''
    },
    hasDVD: {
      type: String,
      default: undefined
    },
    buy: {
      type: Boolean
    },
    rent: {
      type: Boolean
    },
    isPublic: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      locale: 'Global/locale'
    })
  }
}
</script>
<style scoped lang="sass">
@import "../../sass"

.m-availability-links
  .link
    display: block
    padding: 5px 0
    width: fit-content
    color: $black
    &:hover, &:focus
      color: $link-color
    &:focus span
      text-decoration: underline
    @media (min-width: $desktop)
      display: inline-block
</style>
